import { createContext, useContext } from 'react'

import type { ImageComponent, ImageBaseProps } from '../ui/Image/ImageBase'

export type ImageComponentProviderProps = {
  children: React.ReactNode
  imageComponent?: ImageComponent
}

function DefaultImageComponent({
  src,
  alt,
  width,
  height,
  className,
  loading = 'lazy',
}: ImageBaseProps) {
  const isStaticallyImported = typeof src === 'object'
  const imgWidth = width || (isStaticallyImported ? src.width : undefined)
  const imgHeight = height || (isStaticallyImported ? src.height : undefined)

  return (
    <img
      src={typeof src === 'object' ? src.src : src}
      alt={alt || ''}
      width={imgWidth}
      height={imgHeight}
      loading={loading}
      className={className}
    />
  )
}

const ImageComponentContext = createContext<ImageComponent>(
  DefaultImageComponent,
)

export function ImageComponentProvider({
  children,
  imageComponent = DefaultImageComponent,
}: ImageComponentProviderProps) {
  return (
    <ImageComponentContext.Provider value={imageComponent}>
      {children}
    </ImageComponentContext.Provider>
  )
}

export const useImageComponent = () => useContext(ImageComponentContext)
